import { useEffect, useState } from 'react';
import { Box } from '../BoxNew'
import { Image } from '../ImageNew'
import { Text } from '../TextNew'
import { logoTypes } from './LogoTypes'
interface LogoProps {
  hide?: boolean
  logo: string
  name?: string
  type?: keyof typeof logoTypes | Array<keyof typeof logoTypes>
  showTitle?: boolean
}

export type LogoTypesOptions = keyof typeof logoTypes
export const LogoTypesOptionArray = Object.keys(logoTypes)

const Logo = (props: LogoProps) => {
  const { hide = false, logo, name, type = logoTypes.huge, showTitle = true } = props

  const [showPlaceHolder, setShowPlaceHolder] = useState(true)
  useEffect(() => {
    setShowPlaceHolder(!logo || logo === '')
  }, [logo])
  if (hide) {
    return null
  }
  const onError = () => {
    setShowPlaceHolder(true)
  }

  const titleCharacter = name && name.length > 0 ? name?.charAt(0).toUpperCase() : ' '
  return (
    <Box {...logoTypes[type as keyof typeof logoTypes].topContainerStyle} testID="logoBox">
      <Box {...logoTypes[type as keyof typeof logoTypes].containerLogo}>
        {!showPlaceHolder && (
          <Image
            {...logoTypes[type as keyof typeof logoTypes].logo}
            source={logo}
            resizeMode="center"
            onError={onError}
          />
        )}
        {showPlaceHolder && (
          <Box {...logoTypes[type as keyof typeof logoTypes].placeHolderContainer}>
            <Text {...logoTypes[type as keyof typeof logoTypes].placeHolderText}>{titleCharacter}</Text>
          </Box>
        )}
      </Box>
      {showTitle && name && <Text title={name} {...logoTypes[type as keyof typeof logoTypes].topTextStyle} />}
    </Box>
  )
}

export { Logo }
